import type { GetPayoutsParams } from '@pflegenavi/service-provider-frontend/api';

export enum PayoutTabValues {
  All = 'all',
  Paid = 'paid',
  Failed = 'failed',
  Pending = 'pending',
}

export enum PayoutColumn {
  ibanLast4 = '4 Digits',
  initiationDate = 'Initiation Date',
  amount = 'Amount',
  status = 'Status',
  reconciliation = 'Reconciliation',
}

export type PayoutSortColumn = NonNullable<
  GetPayoutsParams['params']['orderBy']
>;
